import { render, staticRenderFns } from "./AverageChart.vue?vue&type=template&id=f218d6d8"
import script from "./AverageChart.vue?vue&type=script&lang=ts"
export * from "./AverageChart.vue?vue&type=script&lang=ts"
import style0 from "./AverageChart.vue?vue&type=style&index=0&id=f218d6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports